<template>
  <material-dialog
    v-on="$listeners"
    cancelText="Anuluj"
    confirmText="Potwierdź"
    title="Potwierdź konto"
    :show="show"
    :width="450"
    :close-on-confirm="false"
    @confirm="confirm"
  >
    <div slot="body">
      <span>
        <small class="mb-2">
          Hasło musi składać się z minimum 14 znaków (w tym cyfry, znaku specjalnego, małej oraz wielkiej litery)
        </small>
      </span>

      <password-input type="password" :model="$schema.password" />

      <password-input title="Powtórz hasło *" type="password" :model="$schema.repeat" />

      <generate-password @generated="setPassword" />
    </div>
  </material-dialog>
</template>

<script>
import { schemaMixin } from '@witkac/vuetify-components';

import GeneratePassword from '@/components/forms/GeneratePassword';
import PasswordInput from '@/components/forms/PasswordInput';
import MaterialDialog from '@/components/material/Dialog';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/confirm.schema';

// @vuese
// Komponent do potwierdzania konta
// @helpers
export default {
  mixins: [notificationsMixin, schemaMixin],
  components: { MaterialDialog, PasswordInput, GeneratePassword },
  props: {
    // czy pokazać modala
    show: { type: Boolean }
  },
  data() {
    return { model: {} };
  },
  schema,
  methods: {
    // @vuese
    // Potwierdza użytkownika
    confirm() {
      if (this.$schema.$validateAll().length) {
        this.notifyError('Należy poprawić błędy formularza.');
        return;
      }
      this.$emit('confirm-user', this.$schema.$getData());
    },
    // @vuese
    // Ustawianie wygenerowanego hasła
    setPassword(password) {
      this.$schema.password.$setData(password);
      this.$schema.repeat.$setData(password);
    }
  },
  watch: {
    show() {
      this.$schema.$setData({ password: '', repeat: '' });
      this.$schema.$reset();
    }
  }
};
</script>
